import React, { Component } from 'react';
import './App.css';
import Brewery from './Brewery';
import 'muicss/dist/css/mui.min.css';
import Container from 'muicss/lib/react/container';
import Input from 'muicss/lib/react/input';
import Button from 'muicss/lib/react/button';

//Firebase

import Firebase from './Firebase';

var favFilter = false;

class App extends Component {

   constructor() {
        super();
        this.state = {
            breweries: {},
            favorites: {},
            searchString: '',
            filteredList: {},
            alphabet: {
                ALL: {val:'',action:'handleChange',isActive:null},
                favorites:{val:'-',action:'favoritesFilter',isActive:null}
            }

        }
        this.renderBrewery = this.renderBrewery.bind(this);
        this.handleChange = this.handleChange.bind(this);

       

        this.favoritesFilter = this.favoritesFilter.bind(this);
        this.renderFilters = this.renderFilters.bind(this);
  



    }

     handleChange(e) {
        this.setActiveFilter(e.target);
        favFilter = false;
        //letterSearch = false;

        this.setState({ searchString: e.target.value });
    }


componentDidMount() {

        const rootRef = Firebase.ref("colorado");
        //console.log(rootRef);
        
        rootRef.on ('value', snap => {
          this.setState({
            breweries:snap.val()
          })
        })


        var localStorageRef = localStorage.getItem(this.props.params.breweries);

        if (localStorageRef) {
            //update our component state and reflect what is in localStorage
            this.setState({
                breweries: JSON.parse(localStorageRef)
            })
        }

    }

     componentWillUnmount() {
    
  }


setActiveFilter(btn) {
    

     const alphabet = this.state.alphabet;
     
      // update state to show active button
    
      for(var i in this.state.alphabet) {


        if (this.state.alphabet.hasOwnProperty(i)) {

           
          if (alphabet[i].val === btn.value) {
            alphabet[i].isActive = true;
          }
          else {  alphabet[i].isActive = null;
          }
    
        }

        this.setState({
       alphabet:this.state.alphabet
    });

     }
  

  }


 favoritesFilter(e) {
    const {isOpened} = this.state;
   this.setActiveFilter(e.target);
   favFilter = true;

   this.setState({searchString: ""});
   this.setState({isOpened: !isOpened});
 }

 resetFilter() {
   
 }

  renderFilters(key) {
      var fn = this.state.alphabet[key].action;

      if (fn === "letterFilter") {

      return (
        <Button variant="raised" key={key} disabled={this.state.alphabet[key].isActive} onClick={this.letterFilter} value={this.state.alphabet[key].val}>{key}</Button>
      )
      }
      if (fn === "handleChange") {
      return (
              <Button variant="raised" key={key} disabled={this.state.alphabet[key].isActive}  onClick={this.handleChange} value={this.state.alphabet[key].val}>{key}</Button>
      )
      }
      if (fn === "favoritesFilter") {
      return (
              <Button variant="raised" key={key}  disabled={this.state.alphabet[key].isActive} onClick={this.favoritesFilter} value={this.state.alphabet[key].val}>Favorites {String.fromCharCode(9733)}</Button>
      )
      }


  }


    renderBrewery(key) {
        

        var searchName = this.state.breweries[key].name.toLowerCase();
        var searchAddress = this.state.breweries[key].address.toLowerCase();
        var searchWord = this.state.searchString.toLowerCase();

        if ((searchName.indexOf(searchWord) !== -1 || searchAddress.indexOf(searchWord) !== -1) && !favFilter) { //found match, return matched value
            return <Brewery key={key} index={key} details={this.state.breweries[key]}/>
        }

        if (favFilter) { //found match, return matched value
                   
                  //Compare the favorites stored in localstorage with the breweries in state
                  var favorites = JSON.parse(localStorage.getItem('favorites'));
                  for (var i = 0; i < favorites.length; i++) {
                    if (favorites[i] === this.state.breweries[key].name) {
                      return <Brewery key={key} index={key} details={this.state.breweries[key]}/>
                    }
                  }
            
                }

    }

    render() {
        return (
            <div>
                <Container fluid={true}>
                    <div className="mui--text-dark-secondary mui--text-display2"><img src="bfh-logo.png" alt="Beer from Here | World Class Beers. Local Breweries" className="logo"/></div>
                    <Input type="text" className="mainSearch" value={this.state.searchString} onChange={this.handleChange} hint="Search brewery name or address" />
                    {Object.keys(this.state.alphabet).map(this.renderFilters)}
                    {Object.keys(this.state.breweries).map(this.renderBrewery) }
                     
                </Container>

            </div>

        )
    }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/